class siteGroup {
  constructor () {
    this._items = {
      0: '不限',
      1: '自站',
      2: '租站'
    }
  }
  get items () {
    return this._items
  }
  list () {
    const _arr = Object.keys(this.items)
    const result = _arr.map(it => {
      return { id: Number(it), value: this.items[it] }
    })
    return result
  }
  allSelect () {
    const _arr = [{ id: 999, value: '全部' }]
    const result = _arr.concat(this.list())
    return result
  }
}

export default new siteGroup()